import type { FC } from 'react';
import React, { useState } from 'react';
import cn from 'classnames';

import type { TTimerText, TValues } from './models';
import { VALUES } from './config';

export const TimerText: FC<TTimerText> = ({
    Case,
    Switch,
    Text,
    Timer,
    breakPoint = '14:00:00',
    styles,
    timerTemplate = '#TIMER#',
    timerText,
    todayText = ' сегодня при оформлении заявки в течение #TIMER#.',
    tomorrowText = ' завтра при оформлении заявки сегодня.',
}) => {
    // На серверном рендере показывает текст при оформлении сегодня
    const [visible, setVisible] = useState<TValues>(VALUES.TODAY);
    const isToday = visible === VALUES.TODAY;
    const [startText, endText] = todayText.split(timerTemplate);

    return (
        <Switch keepMount visible={visible}>
            <Case className={cn(styles.external, { [styles.inline]: isToday })} id={VALUES.TODAY}>
                {startText}
                <Text
                    className={cn({ [styles.default]: !timerText })}
                    noClasses={!timerText}
                    tag="span"
                    {...timerText}
                >
                    <Timer
                        breakPoint={breakPoint}
                        onStart={() => setVisible(VALUES.TODAY)}
                        onStop={() => setVisible(VALUES.TOMORROW)}
                    />
                </Text>
                {endText}
            </Case>
            <Case
                className={cn(styles.external, { [styles.inline]: !isToday })}
                id={VALUES.TOMORROW}
            >
                {tomorrowText}
            </Case>
        </Switch>
    );
};
